
export enum BaseEndpointMappingType {
  BaseMapping = 'BaseMapping',
  GenericEndpoint = 'GenericEndpoint',
  BaseEndpointMapping = 'BaseEndpointMapping'
}
